import styled from 'styled-components'

export const Container = styled.div`
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow-y: auto;
    padding: 10px 10px 10px 10px;
    max-height: 350px;

    &.focus {
        margin-bottom: 200px;
    }

    ::-webkit-scrollbar {
        width: 4px;
    }
    ::-webkit-scrollbar-thumb {
        background-color: #333;
        border-radius: 10px;
    }
    ::-webkit-scrollbar-track {
        background-color: #d3d3d3;
    }

    input {
        width: 100%;
    }

    div {
        .MuiTextField-root {
            .MuiOutlinedInput-root {
                height: 60px;
            }
        }
    }
`
